export const FEDRAMP_MODERATE = 'fedramp-moderate';
